module.exports = __webpack_public_path__ + "static/media/hollow_bar_prewash10.9b2438e0.svg";